import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import CotizacionEnviarRequest from '../../commons/mappings/cotizacionEnviarRequest.mapping';

class CotizacionEnviarProvider {
  constructor() {
    this.paths = URLConfiguration.paths;
    this.cotizacionEnviarRequest = new CotizacionEnviarRequest();
    this.apiProvider = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
  }

  postCotizacionEnviar = async (datosEnvia) => {
    const headers = HeadersMapping.getHeaderService();
    const request =
      this.cotizacionEnviarRequest.postCotizacionEnviar(datosEnvia);
    const pathNew = serviceUtil.replaceParamUrl(
      this.paths.simulacionProductosRentas.cotizacionEnviar,
      {
        idSimulacion: datosEnvia.idSimulacion,
        idCotizacion: datosEnvia.idCotizacion,
      }
    );
    let response = null;
    try {
      response = await this.apiProvider.post(pathNew, request, { headers });
    } catch (error) {
      console.log(error);
    }
    return response;
  };
}

export default CotizacionEnviarProvider;
